module.exports = __webpack_public_path__ + "media/CFWizard3fast.c7aaa5c6.mp4";